import React from 'react';
import Toolbar from 'spark-ui/ui-kitchen/utensils/SplitToolbar';

/**
 Grid Plate Layout
 ----------------------------------
 | Toolbar(left)    Toolbar(right)|
 |--------------------------------|
 |                                |
 |                                |
 |         Grid Content           |
 |                                |
 |________________________________|
 */

//Right now, there's no extra styles that need to be applied,
//but keeping the wrapper for encapsulation.
const Layout = ({ children }) => <div className="grid-layout">{children}</div>;

//Right now, there's no extra styles that need to be applied,
//but keeping the wrapper for encapsulation.
const Content = ({ children }) => <div className="grid-layout-content">{children}</div>;

const gridPlate = {
    Layout,
    Toolbar,
    Content
};
export default gridPlate;
